module.exports = "/fonts/fa-brands-400.ttf?70257b1d0ff04d70da6c3fd1f0cedfd6";